import TextEditorCustomize from '@/components/TextEditorCustomize'
import React from 'react'
import { Controller, Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'

interface Props {
    control: Control<any>
    viewOnly?: boolean
    ticket: any
}

const TicketRemedialMeasures: React.FC<Props> = ({
    control,
    ticket,
    viewOnly = false,
}) => {
    const { t } = useTranslation()
    if (!ticket) return null
    return (
        <div>
            <Typogaphy size="small" className="mb-1">
                {t('ticket-remedial-measures')} *
            </Typogaphy>

            <Controller
                control={control}
                name="ticket_remedial_measures"
                render={({ field, fieldState: { error } }) => {
                    const message =
                        error &&
                        typeof error === 'object' &&
                        'text' in (error as any)
                            ? (error as any).text?.message
                            : undefined

                    return (
                        <div>
                            <TextEditorCustomize
                                disabled={viewOnly}
                                disabledAttachments={true}
                                value={
                                    typeof field.value === 'string'
                                        ? { text: field.value, attachments: [] }
                                        : field.value || {
                                              text: '',
                                              attachments: [],
                                          }
                                }
                                onChange={(val) => field.onChange(val)}
                            />
                            {message && (
                                <p className="text-red-500 text-sm mt-1">
                                    {message}
                                </p>
                            )}
                        </div>
                    )
                }}
            />
        </div>
    )
}

export default TicketRemedialMeasures
